import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  AssignmentCommentFormGroup,
  AssignmentCommentsFormGroup,
  GroupedCommentFormGroup,
} from './assignment-comments-form-group.interface';
import { AssignmentComment } from './assignment-comment.interface';
import { Util } from 'src/app/core/utils/util';

export class AssignmentCommentsFormModel {
  public form: FormGroup<AssignmentCommentsFormGroup>;

  constructor(
    private formBuilder: FormBuilder,
    comments: AssignmentComment[],
  ) {
    const commentsByDate = Util.groupCommentsByDate(comments);

    this.form = formBuilder.group({
      newComment: this.createCommentFormGroup(),
      groupedComments: this.formBuilder.array<
        FormGroup<GroupedCommentFormGroup>
      >(
        Object.keys(commentsByDate).map((date) =>
          this.createCommentsByDateFormGroup(date, commentsByDate[date]),
        ),
      ),
    });
  }

  private createCommentsByDateFormGroup(
    date: string,
    comments: AssignmentComment[],
  ): FormGroup<GroupedCommentFormGroup> {
    return this.formBuilder.group<GroupedCommentFormGroup>({
      date: new FormControl(date, { nonNullable: true }),
      comments: this.formBuilder.array<FormGroup<AssignmentCommentFormGroup>>(
        comments.map((c) => this.createCommentFormGroup(c.id, c.message)),
      ),
    });
  }

  private createCommentFormGroup(
    id?: string,
    message?: string,
  ): FormGroup<AssignmentCommentFormGroup> {
    let formGroup = this.formBuilder.group<AssignmentCommentFormGroup>({
      id: new FormControl(),
      message: new FormControl(null, [Validators.required]),
    });

    if (id && message) {
      formGroup = this.formBuilder.group<AssignmentCommentFormGroup>({
        id: new FormControl(id, { nonNullable: true }),
        message: new FormControl(message, [Validators.required]),
      });
    }

    return formGroup;
  }
}
